type AuthContext = {
  ready: boolean;
  user: { id: string } | null;
  currentRole: string | null;
  isPublicView: boolean;
  isAdmin: boolean;
  adminReady: boolean;
};

type BillingContext = {
  configReady: boolean;
  config: { enabled: boolean };
  configUnavailable: boolean;
  loading: boolean;
  entitlementSource: string;
  entitlement: { userId: string; lifetime: boolean; passExpiresAt?: string | null } | null;
};

/** Resolve eligibility from confirmed state, not the absence of a paid grant.
 * In particular, an authenticated user's pending/offline response is unknown,
 * not evidence they are unpaid. This predicate also guards every mutation. */
export function canEnrollEquipmentCapExperiment(
  auth: AuthContext,
  billing: BillingContext,
): boolean {
  if (!auth.ready || auth.isAdmin || auth.isPublicView) return false;
  if (auth.currentRole !== null &&
      auth.currentRole !== "owner" && auth.currentRole !== "editor") return false;
  if (!billing.configReady || !billing.config.enabled || billing.configUnavailable) return false;
  if (!auth.user) return true;
  // A pass holder is a paying customer like a lifetime holder: never enrolled.
  return auth.adminReady && !billing.loading && billing.entitlementSource === "server" &&
    billing.entitlement?.userId === auth.user.id &&
    billing.entitlement.lifetime === false &&
    !(billing.entitlement.passExpiresAt && Date.parse(billing.entitlement.passExpiresAt) > Date.now());
}
